import React from 'react'
import {Box,Card,CardHeader, CardFooter, CardBody,Text,DataTable,NameValueList, NameValuePair} from 'grommet';
import { Package  } from 'grommet-icons';
import ShipmentQuoteBreakdown from './quoteBreakdown';

function ShipmentBillingSummary(props){
    return (
        <Box border='top'   margin={{top: 'medium', bottom:'small'}} direction='row' justify='center' align='center'>
        <NameValueList margin={{top:'large'}} layout='grid'  pairProps={{ direction: 'column' }} justify='center' align='center'>
        <NameValuePair name="Total Quoted Weight">Total Quoted Weight</NameValuePair>
        <NameValuePair name="Total Quote">Total Quoted Weight</NameValuePair>
        <NameValuePair name="Total Actual Weight">Total Quoted Weight</NameValuePair>
        <NameValuePair name="Total Bill">Total Quoted Weight</NameValuePair>
        </NameValueList>
        
        </Box>
    )
 
}

function ShipmentBillingDetails(props){
      const shipmentSummaryData = props.shipment.pieces.Packages
      const shipmentBillingDetailColumns =  [{property: 'Number',header: "Piece Number",primary: true, footer: 'Total Weight'},{property: 'Commodity',header: 'Commodity', footer: `${props.shipment.total_declared_weight} ${props.shipment.quote.unit_of_measure}`},{property: 'Weight',header: 'Weight', units: '(KG)'},{property: 'Dimensions.Length',header: "Length", units: "(CM)"},{property: 'Dimensions.Width',header: "Width", units: "(CM)"},{property: 'Dimensions.Height',header:"Height", units: "(CM)"}]
      return (
          <Card margin='small' pad='medium' background='background-front' round gap="small" style={{minWidth:720}} hoverIndicator>
               <CardHeader justify='between'>
                  <Box direction='row'><Package color='brand'/><Text margin={{left: 'small'}} weight={'bold'} size="medium">Package Details</Text></Box>
              </CardHeader>
              <CardBody>
              <Box direction='row' justify='between'>
              {/* <Box direction='row' justify='between'><Box direction='row' margin='xsmall'><Tag  background='brand' size='small' name="AWB Number" value={props.shipment.awb_number} /></Box><ReturnLatestTrackingStatus shipment={props.shipment} /></Box> */}
              {/* <ReturnShipmentTracking shipment={props.shipment} load={load} setShowTrackingOverlay={setShowTrackingOverlay} showTrackingOverlay={showTrackingOverlay}  /> */}
              <Box direction='row'>
              {/* <StatusChip shipment={props.shipment} label={'Status'} /> */}
              </Box>
              </Box>
              <Box><DataTable margin='small' background={{header: { color: '#18445C'}}} border={{"body":"bottom"}} columns={shipmentBillingDetailColumns} data={shipmentSummaryData}  /></Box>
              {/* <Box margin='xsmall' direction='row' justify='between'><Text weight='bold'>Total Quoted Weight: {props.shipment.quote.quoted_weight} {props.shipment.quote.unit_of_measure}</Text><Text weight='bold'>Total Billed Weight: {props.shipment.total_billed_weight} {props.shipment.quote.unit_of_measure}</Text></Box> */}
              {(props.user === 'SuperAdmin' ? <Box direction='row'><ShipmentQuoteBreakdown shipment={props.shipment} /><ShipmentQuoteBreakdown shipment={props.shipment} billing={true} /> </Box>: null)}
              <ShipmentBillingSummary props={props} shipmentSummaryData={shipmentSummaryData} />
              </CardBody>         
              <CardFooter>
              {/* <InvoiceChip shipment={props.shipment} /> */}
              </CardFooter>
          </Card>
      )
  }

  export default ShipmentBillingDetails